import React from "react";
import ScrollToTop from "../../ScrollToTop";

const TermsOfUse = () => {
  return (
    <div className="p-10 section">
   <div>

      <div class="max-w-4xl mx-auto p-6 shadow-lg rounded-lg mt-10">
        <h1 class="text-3xl font-bold text-gray-900">Terms of Use</h1>
        <p class="text-sm text-gray-500 mt-2">Effective Date: <span class="font-semibold">[Insert Date Here]</span></p>
        
        <h2 class="text-2xl font-semibold mt-6">Welcome to Pronttera!</h2>
        <p class="mt-4">These Terms of Use (“Terms”) govern your access to and use of the website <a href="https://pronttera.com" class="text-blue-600 hover:underline">https://pronttera.com</a> and all its subdomains (the “Website”), as well as any services offered by Pronttera (the “Services”). By accessing or using our Website or Services, you agree to comply with these Terms.</p>

        <h2 class="text-xl font-semibold mt-6">1. About Us</h2>
        <p class="mt-4">Pronttera (“Company”, “we”, “us”, or “our”) is a provider of tailored software solutions, collaboration opportunities, and technology consultations.</p>

        <h2 class="text-xl font-semibold mt-6">2. Eligibility</h2>
        <p class="mt-4">By using the Website or Services, you confirm that you are at least 18 years old or accessing the Website under the supervision of a parent or legal guardian.</p>

        <h2 class="text-xl font-semibold mt-6">3. Use of the Website and Services</h2>
        <h3 class="font-medium mt-4">Permitted Use</h3>
        <ul class="list-disc ml-6 mt-2">
            <li>Provide accurate and up-to-date information during registration.</li>
            <li>Use the Website and Services only for lawful purposes.</li>
        </ul>
        
        <h3 class="font-medium mt-4">Prohibited Use</h3>
        <ul class="list-disc ml-6 mt-2">
            <li>Harming, threatening, or harassing others.</li>
            <li>Uploading viruses or malware.</li>
            <li>Gaining unauthorized access to the Website or Services.</li>
        </ul>

        <h2 class="text-xl font-semibold mt-6">4. Account Registration</h2>
        <p class="mt-4">To access certain Services, you may need to create an account. You are responsible for maintaining the confidentiality of your account credentials.</p>

        <h2 class="text-xl font-semibold mt-6">5. Intellectual Property Rights</h2>
        <p class="mt-4">All content on the Website, including text, graphics, logos, and trademarks, is owned by Pronttera. Unauthorized reproduction is prohibited.</p>

        <h2 class="text-xl font-semibold mt-6">6. Payment Terms</h2>
        <p class="mt-4">Some Services may require payment. Payments are processed through secure third-party providers.</p>

        <h2 class="text-xl font-semibold mt-6">7. Privacy Policy</h2>
        <p class="mt-4">Your use of the Website is subject to our <a href="[Privacy Policy Link]" class="text-blue-600 hover:underline">Privacy Policy</a>.</p>

        <h2 class="text-xl font-semibold mt-6">8. Third-Party Links and Services</h2>
        <p class="mt-4">We are not responsible for third-party websites linked on our Website.</p>

        <h2 class="text-xl font-semibold mt-6">9. Limitation of Liability</h2>
        <p class="mt-4">Pronttera is not liable for any indirect, incidental, or consequential damages arising from your use of the Website or Services.</p>

        <h2 class="text-xl font-semibold mt-6">10. Indemnification</h2>
        <p class="mt-4">You agree to indemnify and hold harmless Pronttera from any claims or damages resulting from your use of the Website or Services.</p>

        <h2 class="text-xl font-semibold mt-6">11. Termination</h2>
        <p class="mt-4">We reserve the right to terminate your access to the Website and Services at any time.</p>

        <h2 class="text-xl font-semibold mt-6">12. Modifications to the Terms</h2>
        <p class="mt-4">We may update these Terms from time to time. Continued use of the Website indicates your acceptance of the updated Terms.</p>

        <h2 class="text-xl font-semibold mt-6">13. Governing Law and Dispute Resolution</h2>
        <p class="mt-4">These Terms shall be governed by the laws of India, with disputes subject to the jurisdiction of Pune, Maharashtra.</p>

        <h2 class="text-xl font-semibold mt-6">14. Grievance Redressal</h2>
        <p class="mt-4">If you have any concerns, please contact us at:</p>
        <ul class="list-disc ml-6 mt-2">
            <li>Email: <a href="mailto:contact@pronttera.com" class="text-blue-600 hover:underline">contact@pronttera.com</a></li>
            <li>Phone: +91 9834174885</li>
            <li>Address: Shah Building, First Floor, Kalas, Alandi Road, Pune</li>
        </ul>

        <h2 class="text-xl font-semibold mt-6">15. Entire Agreement</h2>
        <p class="mt-4">These Terms, along with our Privacy Policy, constitute the entire agreement between you and Pronttera.</p>

        <p class="text-sm text-gray-500 mt-6">YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD THESE TERMS OF USE AND AGREE TO BE BOUND BY THEM.</p>
    </div>
    </div>
   </div>
  );
};

export default TermsOfUse;
